import CarConsolidationLoan from './CarConsolidationLoan';
import { NAME } from './constants';
import reducer from './reducer';
import * as actions from './actions';

export default {
  CarConsolidationLoan,
  NAME,
  reducer,
  actions,
};
